

























































































import Vue from 'vue'
import _ from 'lodash'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import { FETCH_EMPLOYEE_LEVEL, GET_EMPLOYEE_SECURITY, UPDATE_EMPLOYEE_LEVEL } from '@/store/action-types'
import {
  EmployeeSecurityRoleResponse,
  GetEmployeeLevelResponse,
  ResponseBase,
  SecurityRole
} from '@/types/service-response'
import { EmployeeSecurityLevel } from '@/model/settings/EmployeeSecurityLevel'
import { hexToRgba } from '@/services/hex-to-rgba'
import { EmployeeDepartment } from '@/model/settings/EmployeeDepartment'
import { UpdateProfitCenterAndDepartmentItem, UpdateProfitCenterAndDepartmentPayload } from '@/types/payload'
import { SnackbarStateEnum } from '@/types/enums'

interface ComponentData {
  tableHeight: string,
  gridData: EmployeeSecurityLevel[]
  originalData: EmployeeSecurityLevel[]
  departmentList: EmployeeDepartment[]
  currentSelectedRowKey: number | null
  currentSelectedRowData: EmployeeSecurityLevel | undefined
  showSearchField: boolean
  search: string | null
  isEdit: boolean
  payloadData: UpdateProfitCenterAndDepartmentItem[] | undefined
  securityList: SecurityRole[]
  selectedSecurityId: number | undefined

  showSnackbar: boolean
  messageSnackbar: string
  snackbarState: number
  isEditLoading: boolean
}

export default Vue.extend({
  name: 'EmployeeSecurityPage',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection
  },

  props: {

  },

  data (): ComponentData {
    return {
      tableHeight: '',
      gridData: [],
      originalData: [],
      departmentList: [],
      currentSelectedRowKey: null,
      currentSelectedRowData: undefined,
      showSearchField: false,
      search: null,
      isEdit: false,
      payloadData: undefined,
      securityList: [],
      selectedSecurityId: undefined,

      showSnackbar: false,
      messageSnackbar: '',
      snackbarState: 0,
      isEditLoading: false
    }
  },

  watch: {
    search (): void {
      if(this.payloadData || this.selectedSecurityId) {
        this.payloadData = undefined
        this.selectedSecurityId = undefined
        this.isEdit = false
        this.gridData = _.cloneDeep(this.originalData)
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isEnableEditButton (): boolean {
      return !!(this.currentSelectedRowData)
    },

    isSearchEnabled (): boolean {
      return this.gridData.length > 0
    },

    filteredGridData (): EmployeeSecurityLevel[] {
      if(this.search) {
        return this.gridData.filter((item: EmployeeSecurityLevel) => {
          if(item.Vorname && item.Name) {
            return `${item.Vorname} ${item.Name}`.toLowerCase().includes(this.search!.toLowerCase())
          } else if(item.Vorname) {
            return item.Vorname.toLowerCase().includes(this.search!.toLowerCase())
          } else if(item.Name) {
            return item.Name.toLowerCase().includes(this.search!.toLowerCase())
          } else {
            return false
          }
        })
      } else {
        return this.gridData
      }
    }
  },

  methods: {
    getSecurityRoleLabel(securityRole: number): string {
      const foundSecurityRole: SecurityRole | undefined = this.securityList.find((item: SecurityRole) => item.SecurityRolle === securityRole)
      if(foundSecurityRole) {
        return foundSecurityRole.Bezeichnung
      } else {
        return ''
      }
    },

    onAddButtonClick (): void {

    },

    onEditButtonClick (): void {
      if(this.currentSelectedRowData) {
        this.payloadData = this.currentSelectedRowData.UserDepartments.map((i: EmployeeDepartment) => {
          return {
            Employee: this.currentSelectedRowData!.ID,
            ProfitCenter: i.Profitcenter,
            Department: i.Abteilung,
            SecurityRollenFunktion: 1
          }
        })
        this.selectedSecurityId = this.currentSelectedRowData.SecurityRolle
      }
      this.isEdit = true
    },

    onDeleteButtonClick (): void {

    },

    onSearchButtonClick (): void {
      this.showSearchField = !this.showSearchField
      if(!this.showSearchField) {
        this.search = null
      }
    },

    onRowClick (data: any): void {
      if(this.currentSelectedRowKey !== data.key) {
        if(this.payloadData || this.selectedSecurityId) {
          this.payloadData = undefined
          this.selectedSecurityId = undefined
          this.isEdit = false
          this.gridData = _.cloneDeep(this.originalData)
        }
        this.currentSelectedRowKey = data.key
        this.currentSelectedRowData = this.gridData[data.loadIndex]
      }
    },

    onCancelClick (): void {
      this.payloadData = undefined
      this.selectedSecurityId = undefined
      this.isEdit = false
      this.gridData = _.cloneDeep(this.originalData)
      if(this.currentSelectedRowKey) {
        const foundSelectedRowData: EmployeeSecurityLevel | undefined = this.gridData.find((item: EmployeeSecurityLevel) => item.ID === this.currentSelectedRowKey)
        if(foundSelectedRowData) {
          this.currentSelectedRowData = foundSelectedRowData
        }
      }
    },

    onSecuritySelectChange (item: EmployeeSecurityLevel): void {
      this.selectedSecurityId = item.SecurityRolle
    },

    onSelectChange(item: EmployeeSecurityLevel): void {
      this.payloadData = item.UserDepartments.map((i: EmployeeDepartment) => {
        return {
          Employee: item.ID,
          ProfitCenter: i.Profitcenter,
          Department: i.Abteilung,
          SecurityRollenFunktion: 1
        }
      })
    },

    onResize (): void {
      if(this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          this.tableHeight = `height: calc(${vh}px - 160px)`
        } else {
          this.tableHeight = 'height: 300px'
        }
      } else {
        this.tableHeight = 'height: 300px'
      }
    },

    async onSaveClick (): Promise<void> {
      if((this.payloadData || this.selectedSecurityId) && this.currentSelectedRowKey != null) {
        const payload: UpdateProfitCenterAndDepartmentPayload = {
          Employee: this.currentSelectedRowKey,
          AddUpdate: this.payloadData ? this.payloadData : [],
          SecurityRole: this.selectedSecurityId!
        }

        try {
          this.isEditLoading = true
          const response: ResponseBase = await this.$store.dispatch(UPDATE_EMPLOYEE_LEVEL, payload)
          this.isEditLoading = false
          if (!response.IsError) {
            this.isEdit = false
            this.payloadData = undefined
            this.selectedSecurityId = undefined
            this.snackbarState = SnackbarStateEnum.Success
            this.messageSnackbar = this.$t('success.dataHaveBeenSaved').toString()
            this.showSnackbar = true
            this.fetchData()
          } else {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.isEditLoading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    async fetchEmployeeSecurity (): Promise<void> {
      try {
        const response: EmployeeSecurityRoleResponse = await this.$store.dispatch(GET_EMPLOYEE_SECURITY)
        if(response && !response.IsError && response.Data) {
          this.securityList = response.Data
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      try {
        const response: GetEmployeeLevelResponse = await this.$store.dispatch(FETCH_EMPLOYEE_LEVEL)
        if(response) {
          if(response.MitarbeiterLevels) {
            this.gridData = response.MitarbeiterLevels ? EmployeeSecurityLevel.createFromResponse(response.MitarbeiterLevels) : []
            this.originalData = _.cloneDeep(this.gridData)
          }
          if(response.Abteilungen) {
            this.departmentList = EmployeeDepartment.createFromDepartmentResponse(response.Abteilungen)
          }
          if(this.currentSelectedRowKey) {
            const foundItem: EmployeeSecurityLevel | undefined = this.gridData.find((item: EmployeeSecurityLevel) => item.ID === this.currentSelectedRowKey)
            this.currentSelectedRowData = foundItem ? foundItem : undefined
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted () {
    this.fetchEmployeeSecurity()
    this.fetchData()
  }
})
